<template>
  <div class="saleBanner" v-if="dataList.length">
    <h3 class="title">{{ dataSource.title || "特价" }}</h3>
    <div class="saleaBannerArea">
      <el-carousel
        :interval="5000"
        arrow="always"
        :indicator-position="'none'"
        :autoplay="false"
      >
        <el-carousel-item v-for="(item, index) in showList" :key="index">
          <div class="bannerList">
            <div v-for="j in item" :key="j.skuId" class="bannerItem">
              <img v-if="j.fileUrl" class="item-img" :src="j.fileUrl" />
              <img
                v-else
                class="item-img"
                src="~@/assets/img/bitmap.png"
                style="object-fit: contain"
              />
              <div class="item-name ellipsis-2">
                {{ j.skuName }}
              </div>
              <div
                class="item-btn-area cursor-pointer"
                :style="{
                  fontSize: getFontSize(j.sellingPrice),
                }"
                @click="toBuy(j)"
              >
                <template v-if="!j.isSellingPriceExpire">
                  <span class="price">￥</span>
                  <span class="price">{{
                    formatePrice((+j.sellingPrice || 0).toFixed(2))
                  }}</span>
                  <span>/{{ j.sellingUnit }}</span>
                </template>
                <span v-else>待询价</span>
                <img
                  class="btn_icon"
                  src="~@/assets/img/main/home/saleBanner_btn_icon.png"
                  alt="btn_icon"
                />
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { formatePrice } from "@/utils/formatePrice";
import { openOther } from "@/utils/index";

export default {
  data() {
    return {
      dataSource: {},
      dataList: [],
    };
  },
  computed: {
    showList() {
      const result = [];
      for (let i = 0; i < this.dataList.length; i += 5) {
        result.push(this.dataList.slice(i, i + 5));
      }
      return result;
    },
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    toBuy(res) {
      if (!res.spuId && !res.skuId) {
        return;
      }
      openOther(`goodDetail?spuId=${res.spuId}&skuId=${res.skuId}`);
    },
    getFontSize(sellingPrice) {
      // const l = Math.floor((Math.floor(+sellingPrice) + "").length / 3);
      const priceStr = formatePrice((+sellingPrice || 0).toFixed(2));
      // 最大18 最小11
      return Math.max(Math.min(120 / (priceStr.length + 3), 18), 12) + "px";
    },
    getInfo() {
      this.$http
        .get(
          `/front/cross/commodity-user/activity/topic/details?activityCode=MKT0527`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataSource = res.data || {};
            this.getGoodsList();
          }
        });
    },
    getGoodsList() {
      if (
        !this.dataSource.floors ||
        !this.dataSource.floors[0] ||
        !this.dataSource.floors[0].children ||
        !this.dataSource.floors[0].children[0]
      ) {
        return;
      }
      this.$http
        .post(`/front/cross/commodity-user/activity/topic/commodity/list`, {
          activityId: this.dataSource.activityId,
          floorIds: [this.dataSource.floors[0].children[0].floorId],
          limit: 100,
          page: 1,
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data[0].dataList || [];
          }
        });
    },
    formatePrice,
  },
};
</script>

<style lang="scss" scoped>
.saleBanner {
  font-family: AlibabaPuHuiTi;
  margin-top: 32px;
  .title {
    font-family: Alimama ShuHeiTi;
    font-size: 24px;
    font-weight: 700;
    line-height: 29.42px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #333;
  }
  .saleaBannerArea {
    border-radius: 18px;
    background: linear-gradient(180deg, #2a54d1 0%, rgba(42, 84, 209, 0) 100%),
      url("~@/assets/img/main/home/saleBanner_bg.png");
    background-size: cover, 100% 100%;
  }

  .bannerItem {
    width: 190px;
    height: 286px;
    background: #fff;
    border-radius: 16px;
    padding: 8px;
  }
  .bannerList {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 300px;
    padding: 0 28px;
  }
  .item-img {
    width: 174px;
    height: 174px;
    border-radius: 16px;
    background: #ffffff;
    box-sizing: border-box;
    border: 2px solid #f5f6fa;
  }
  .item-name {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    height: 3em;
    margin: 10px 0;
    word-break: break-all;
  }
  .item-btn-area {
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid rgba(233, 48, 55, 0.2);
    padding: 2px 8px;
    height: 32px;
    position: relative;
    font-size: 18px;
    line-height: 26px;
    &:hover {
      opacity: 0.9;
    }
    .price {
      font-weight: bold;
      color: #e93037;
    }
    .btn_icon {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  ::v-deep .el-carousel__arrow {
    border-radius: 20px;
    opacity: 0.5;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-icon-arrow-right {
    font-size: 30px;
    font-weight: bold;
    color: #666;
  }
  ::v-deep .el-icon-arrow-left {
    font-size: 30px;
    font-weight: bold;
    color: #666;
  }
}
</style>
